import _get from 'lodash/get';
import {apiRateLimitHit} from '../actions/rateLimit';

export function checkStatus(response) {
  if (!response.ok) { //(response.status < 200 || response.status > 300)
    const error = new Error(response);
    error.response = response;

    throw error;
  }

  return response;
}

//dh why is this method necessary?
export function parseJSON(response) {
  return response.json();
}

/**
 * A utility to call a restful service.
 *
 * @param url The restful service end point.
 * @param config The config object of the call. Can be null.
 * @param onRequest The callback function to create request action.
 * @param onRequestSuccess The callback function to create request success action.
 *                 The function expects response json payload as its argument.
 * @param onRequestFailure The callback function to create request failure action.
 *                 The function expects error as its argument.
 * @param options Additional options which may be passed through
 *
 */
export function api(url, config, onRequest, onRequestSuccess, onRequestFailure, options = {}) {
  return (dispatch) => {
    dispatch(onRequest);
    return fetch(url, config)
      .then(checkStatus)
      .then(parseJSON)
      .then((json) => {
        return dispatch(onRequestSuccess(json, options));
      })
      .catch((error) => {
        if (error.response === undefined) {
          return dispatch(onRequestFailure(error, options));
        }

        return error.response.json()
          .then((json) => {
            const response = json;

            if (response === undefined || Object.keys(response).length === 0) {
              return dispatch(onRequestFailure(error, options));
            }

            const errorReturn = {
              status: _get(error, 'response.status', {}),
              statusText: _get(error, 'response.statusText', {}),
              message: _get(response, 'message', {}),
              code: _get(response, 'errorCode', {}),
              statusCode: _get(response, 'statusCode', 0),
              memSiteAccountId: _get(response, 'memSiteAccountId', 0)
            };


            if (errorReturn.status === 429) {
              return dispatch(apiRateLimitHit(errorReturn));
            }

            return dispatch(onRequestFailure(errorReturn, options));

          }, () => {
            // unable to parse error response
            const errorReturn = {
              status: _get(error, 'response.status', {}),
              statusText: _get(error, 'response.statusText', {})
            };
            return dispatch(onRequestFailure(errorReturn, options));
          })

      });
  };
}



// WEBPACK FOOTER //
// ./src/helpers/api.js